export const rolTypes = {
  1: 'aprobador',
  2: 'revisor',
  3: 'firmante',
  4: 'visador',
  5: 'configurador',
};

export const rolTypesCode = {
  aprobador: '1',
  revisor: '2',
  firmante: '3',
  visador: '4',
  configurator: '5'
};

export const stepTypes = {
  1: 'grupo',
  2: 'usuario',
  3: 'proveedor',
  4: 'cliente',
  5: 'persona',
  6: 'oficina',
  7: 'oficial',
  9: 'completitud'
};

export const stepTypesCode = {
  grupo: 1,
  usuario: 2,
  proveedor: 3,
  cliente: 4,
  persona: 5,
  oficina: 6,
  oficial: 7,
  completitud: 9
};

export const signerProviderConfigs = {
  default: {
    key: 'default',
    description: '',
    simple: true,
    otp: true,
    coordenadas: true,
    password: false
  },
  Febos: {
    key: 'Febos',
    description: 'Simple Febos',
    simple: true,
    otp: true,
    coordenadas: true,
    password: false
  },
  AEcert: {
    key: 'AEcert',
    description: 'Avanzada Ecert',
    simple: false,
    otp: true,
    coordenadas: true,
    password: false
  },
  EDigital: {
    key: 'EDigital',
    description: 'Simple E-Digital',
    simple: true,
    otp: true,
    coordenadas: true,
    password: false
  },
  SAgile: {
    key: 'SAgile',
    description: 'Simple Agile',
    simple: true,
    otp: false,
    coordenadas: true,
    password: false
  },
  Segpres: {
    key: 'Segpres',
    description: 'Avanzada Segpres',
    simple: false,
    otp: true,
    coordenadas: true,
    password: false
  },
  esign7: {
    key: 'esign7',
    description: 'Avanzada Esign',
    simple: false,
    otp: true,
    coordenadas: true,
    password: false
  },
  Esign: {
    key: 'Esign',
    description: 'Avanzada Esign',
    simple: false,
    otp: true,
    coordenadas: true,
    password: false
  },
  FirmadorMinisterioEconomia: {
    key: 'FirmadorMinisterioEconomia',
    description: 'Avanzada Ministerio de Economia',
    simple: false,
    otp: true,
    coordenadas: false,
    password: false
  },
  THSign: {
    key: 'THSign',
    description: 'Avanzada Thomas Sign',
    simple: false,
    otp: true,
    coordenadas: true,
    password: false
  },
  ASignAPI: {
    key: 'ASignAPI',
    description: 'Avanzada SignAPI',
    simple: false,
    otp: false,
    coordenadas: true,
    password: false,
    configureOnSelect(signUser) {
      console.log('configureOnSelect', signUser, this);
      if (!signUser.atendida) {
        this.otp = true;
      }
    }
  },
  S_SignAPI_E: {
    key: 'S_SignAPI_E',
    description: 'Simple SignAPI',
    simple: true,
    otp: false,
    coordenadas: true,
    password: false
  },
};
